import BoundaryLegendClassificationType from "@mapmycustomers/shared/enum/boundaryLegends/BoundaryLegendClassificationType";

import ClassificationMethod from "@app/store/mapLayers/boundaries/types/ClassificationMethod";

const classificationMethodMap: Partial<
  Record<BoundaryLegendClassificationType, ClassificationMethod>
> = {
  [BoundaryLegendClassificationType.EQUAL_INTERVAL]: ClassificationMethod.EQUAL_INTERVAL,
  [BoundaryLegendClassificationType.MANUAL]: ClassificationMethod.MANUAL,
  [BoundaryLegendClassificationType.NATURAL_BREAKS]: ClassificationMethod.NATURAL_BREAKS,
  [BoundaryLegendClassificationType.QUANTILE]: ClassificationMethod.QUANTILE,
};

export default classificationMethodMap;
